exports.tables = {
				'en':{
					'NMDI Drought': {	
							title: "NMDI Drought",
							subtitle: "Value interpretation",
							headers: ["Value", "Condition"],
							rows: [
							  ["> 0.6", "Very wet"],
							  ["0.4 - 0.6", "Wet"],
							  ["< 0.4", "Dry"],
							  ["< 0.2", "Very dry"],
							],
						  },
					'NDMI Moiusture': {	
							title: "NDMI Moiusture",
							subtitle: "Value interpretation",
							headers: ["Value", "Condition"],
							rows: [
							  ["-1.0 - -0.8", "Bare soil"],
							  ["-0.8 - -0.6", "Almost absent canopy cover"],
							  ["-0.6 - -0.4", "Very low canopy cover"],
							  ["-0.4 - -0.2", "Low canopy cover, dry or very low canopy cover, wet"],
							  ["-0.2 - 0.0", "Mid-low canopy cover, high water stress or low canopy cover, low water stress"],
							  ["0.0 - 0.2", "Average canopy cover, high water stress or mid-low canopy cover, low water stress"],
							  ["0.2 - 0.4", "Mid-high canopy cover, high water stress or average canopy cover, low water stress"],
							  ["0.4 - 0.6", "High canopy cover, no water stress"],
							  ["0.6 - 0.8", "Very high canopy cover, no water stress"],
							  ["0.8 - 1.0", "Total canopy cover, no water stress/ waterlogging"],
							],
						  },
					'LST Temperature': {	
							title: "LST Temperature",
							subtitle: "Value interpretation",
							headers: ["Value", "Condition"],
							rows: [
							  ["> 35°C", "Soil overheating - Root survival can be negatively affected, which can lead to root death"],
							  ["~24°C", "Soil warming - promote shoot growth by increasing the use of starch reserves"],
							  ["~13°C", "Soil cooling - starch accumulation, biomass partitioning to the root system"],
							],	// vir: https://www.frontiersin.org/journals/plant-science/articles/10.3389/fpls.2023.1145137/full
						  },
					'NDVI Vegetation': {	
							title: "NDVI Vegetation",
							subtitle: "Value interpretation",
							headers: ["Value", "Condition"],
							rows: [
							  ["0.0 - 0.1", "Bare soil"],
							  ["0.1 - 0.2", "Almost absent canopy cover"],
							  ["0.2 - 0.3", "Very low canopy cover"],
							  ["0.3 - 0.4", "Low canopy cover, low vigour or very low canopy cover, high vigour"],
							  ["0.4 - 0.5", "Mid-low canopy cover, low vigour or low canopy cover, high vigour"],
							  ["0.5 - 0.6", "Average canopy cover, low vigour or mid-low canopy cover, high vigour"],
							  ["0.6 - 0.7", "Mid-high canopy cover, low vigour or average canopy cover, high vigour"],
							  ["0.7 - 0.8", "High canopy cover, high vigour"],
							  ["0.8 - 0.9", "Very high canopy cover, very high vigour"],
							  ["0.9 - 1.0", "Total canopy cover, high vigour"],
							],
						  }
				},
				"si":{
					'NMDI Drought': {	
							title: "NMDI Sušni indeks",
							subtitle: "Interpretacija vrednosti",
							headers: ["Vrednost", "Stanje"],
							rows: [
							  ["> 0,6", "Zelo mokro"],
							  ["0,4 - 0,6", "Mokro"],
							  ["< 0,4", "Suho"],
							  ["< 0,2", "Zelo suho"],
							],
						  },
					'NDMI Moiusture': {	
							title: "NDMI Indeks vlažnosti",
							subtitle: "Interpretacija vrednosti",
							headers: ["Vrednost", "Stanje"],
							rows: [
							  ["-1,0 - -0,8", "Gola prst"],
							  ["-0,8 - -0,6", "Skoraj popolna odsotnost vegetacije"],
							  ["-0,6 - -0,4", "Zelo nizka stopnja vegetacije"],
							  ["-0,4 - -0,2", "Nizka stopnja vegetacije - suho ali zelo nizka stopnja vegetacije - mokro"],
							  ["-0,2 - 0,0", "Srednja stopnja vegetacije - visok vodni stres ali nizka stopnja vegetacije - nizek vodni stres"],
							  ["0,0 - 0,2", "Povprečna stopnja vegetacije - visok vodni stres ali srednje-nizka stopnja vegetacije - nizek vodni stres"],
							  ["0,2 - 0,4", "Srednje visoka stopnja vegetacije - visok vodni stres ali povprečna stopnja vegetacije - nizek vodni stres"],
							  ["0,4 - 0,6", "Visoka stopnja vegetacije - brez vodnega stresa"],
							  ["0,6 - 0,8", "Zelo visoka stopnja vegetacije - brez vodnega stresa"],
							  ["0,8 - 1,0", "Popolna vegetacija - brez vodnega stresa / prepojenost prsti z vodo"],
							],
						  },
					'LST Temperature': {	
							title: "LST Temperaturni indeks",
							subtitle: "Interpretacija vrednosti",
							headers: ["Vrednost", "Stanje"],
							rows: [
							  ["> 35°C", "Pregrevanje prsti - Negativni vpliv na korenine, lahko vodi v odmiranje korenin"],
							  ["~24°C", "Segrevanje prsti - Spodbujena rast poganjkov s povečano porabo zalog škroba"],
							  ["~13°C", "Ohlajanje prsti - Akomulacija škroba, razdelitev biomase na koreninski sistem"],
							],	// vir: https://www.frontiersin.org/journals/plant-science/articles/10.3389/fpls.2023.1145137/full
						  },
					'NDVI Vegetation': {	
							title: "NDVI Indeks vegetacije",
							subtitle: "Interpretacija vrednosti",
							headers: ["Vrednost", "Stanje"],
							rows: [
							  ["0,0 - 0,1", "Gola prst"],
							  ["0,1 - 0,2", "Skoraj popolna odsotnost vegetacije"],
							  ["0,2 - 0,3", "Zelo nizka stopnja vegetacije"],
							  ["0,3 - 0,4", "Nizka stopnja vegetacije - nizki vigor ali elo nizka stopnja vegetacije - visok vigor"],
							  ["0,4 - 0,5", "Srednje nizka stopnja vegetacije - nizki vigor ali nizka stopnja vegetacije- visok vigor"],
							  ["0,5 - 0,6", "Povprečna stopnja vegetacije - nizki vigor ali srednje nizka stopnja vegetacije - visok vigor"],
							  ["0,6 - 0,7", "Srednje visoka stopnja vegetacije - nizki vigor ali povprečna stopnja vegatacije - visok vigor"],
							  ["0,7 - 0,8", "Visoka stopnja vegetacije - visok vigor"],
							  ["0,8 - 0,9", "Zelo visoka stopnja vegetacije - zelo visok vigor"],
							  ["0,9 - 1,0", "Popolna vegetacija - zelo visok vigor"],
							],
						  }
				},
				"it":{
					'NMDI Drought': {	
							title: "NMDI Siccità",
							subtitle: "Interpretazione del valore",
							headers: ["Valore", "Condizione"],
							rows: [
							  ["> 0.6", "Molto umido"],
							  ["0.4 - 0.6", "Umido"],
							  ["< 0.4", "Asciutto"],
							  ["< 0.2", "Molto asciutto"],
							],
						  },
					'NDMI Moiusture': {	
							title: "NDMI Umidità",
							subtitle: "Interpretazione del valore",
							headers: ["Valore", "Condizione"],
							rows: [ ["-1.0 - -0.8", "Suolo nudo"], 
									["-0.8 - -0.6", "Copertura vegetale quasi assente"], 
									["-0.6 - -0.4", "Copertura vegetale molto bassa"], 
									["-0.4 - -0.2", "Copertura vegetale bassa con stress idrico alto o copertura vegetale molto bassa con stress idrico basso"], 
									["-0.2 - 0.0", "Copertura vegetale medio-bassa con stress idrico alto o copertura vegetale bassa con stress idrico basso"], 
									["0.0 - 0.2", "Copertura vegetale media con stress idrico alto o copertura vegetale medio-bassa con stress idrico basso"], 
									["0.2 - 0.4", "Copertura vegetale medio-alta con stress idrico alto o copertura vegetale media con stress idrico basso"], 
									["0.4 - 0.6", "Copertura vegetale alta e no stress idrico"], 
									["0.6 - 0.8", "Copertura vegetale molto alta e no stress idrico"], 
									["0.8 - 1.0", "Copertura vegetale totale, nessuno stress idrico o ristagni o nuvole"] 
								],
						  },
					'LST Temperature': {	
							title: "LST Temperatura",
							subtitle: "Interpretazione del valore",
							headers: ["Valore", "Condizione"],
							rows: [ ["> 35°C", "Sovrariscaldamento del suolo - la sopravvivenza delle radici può essere negativamente influenzata, il che può portare alla morte delle radici"], 
							["~24°C", "Riscaldamento del suolo - promuove la crescita delle parti aeree aumentando l'utilizzo delle riserve di amido"], 
							["~13°C", "Raffreddamento del suolo - accumulo di amido, ripartizione della biomassa nel sistema radicale"] 
							],	// vir: https://www.frontiersin.org/journals/plant-science/articles/10.3389/fpls.2023.1145137/full
						  },
					'NDVI Vegetation': {	
							title: "NDVI Vegetazione",
							subtitle: "Interpretazione del valore",
							headers: ["Valore", "Condizione"],
							rows: [ ["0.0 - 0.1", "Suolo nudo"], 
									["0.1 - 0.2", "Copertura del vegetale quasi assente"], 
									["0.2 - 0.3", "Copertura del vegetale molto bassa"], 
									["0.3 - 0.4", "Bassa copertura del vegetale, bassa vitalità o molto bassa copertura del vegetale, alta vitalità"], 
									["0.4 - 0.5", "Copertura del vegetale medio-bassa, bassa vitalità o bassa copertura del vegetale, alta vitalità"], 
									["0.5 - 0.6", "Copertura del vegetale media, bassa vitalità o copertura del vegetale medio-bassa, alta vitalità"], 
									["0.6 - 0.7", "Copertura del vegetale medio-alta, bassa vitalità o copertura del vegetale media, alta vitalità"], 
									["0.7 - 0.8", "Alta copertura del vegetale, alta vitalità"], 
									["0.8 - 0.9", "Molto alta copertura del vegetale, molto alta vitalità"], 
									["0.9 - 1.0", "Copertura del vegetale totale, molto alta vitalità"], 
								],
						  }
				}
		}